import React from 'react'
import RatingBar from './RatingBar';
import ActionBar from './ActionBar';

export default function BookCard({ book }) {
  const { id, name, author, thumbnail, price, rating, featured } = book;

  return (
    <div class="book-card">
      <img class="h-[240px] w-[170px] object-cover"
        src={thumbnail} alt={name} />
      <div class="flex-1 h-full pr-2 pt-2 flex flex-col">
        <div class="flex items-center justify-between">
          {featured ? <span class="lws-badge">featured</span> : <span></span>}
          <ActionBar bookId={id} />
        </div>

        <div class="space-y-2 mt-4 h-full">
          <h4 class="lws-book-name">{name}</h4>
          <p class="lws-author">{author}</p>
          <RatingBar number={rating} />
          <p class="lws-price">BDT {price}</p>
        </div>
      </div>
    </div>
  )
}
